function getMetaTag(vm, tag) {
  const metaTag = vm.$options[tag];
  if (metaTag) {
    return typeof metaTag === 'function' ? metaTag.call(vm) : metaTag;
  }
}

function getJsonLd(vm) {
  const jsonLd = vm.$options.jsonLd;
  if (jsonLd) {
    return typeof jsonLd === 'function' ? jsonLd.call(vm) : jsonLd;
  }
}

function updateMeta(vm) {
  const title = getMetaTag(vm, 'title');
  const description = getMetaTag(vm, 'description');
  const canonicalLink = getMetaTag(vm, 'canonicalLink');
  const jsonLd = getJsonLd(vm);

  if (title) {
    document.title = title;
  }

  if (description) {
    let descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (!descriptionMetaTag) {
      descriptionMetaTag = document.createElement('meta');
      descriptionMetaTag.name = 'description';
      document.head.appendChild(descriptionMetaTag);
    }
    descriptionMetaTag.content = description;
  }

  if (canonicalLink) {
    let canonicalLinkTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalLinkTag) {
      canonicalLinkTag = document.createElement('link');
      canonicalLinkTag.rel = 'canonical';
      document.head.appendChild(canonicalLinkTag);
    }
    canonicalLinkTag.href = canonicalLink;
  }

  if (jsonLd) {
    let scriptTag = document.querySelector('script[type="application/ld+json"]');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }
    scriptTag.innerHTML = JSON.stringify(jsonLd);
  }
}

export default {
  created() {
    updateMeta(this);
  },
  methods: {
    updateMeta() {
      updateMeta(this);
    },
  },
};
